import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "readout" ]

  readoutConnected() {
    this.readoutTarget.classList.add("opacity-0", "translate-y-2")
    requestAnimationFrame(() => {
      this.readoutTarget.classList.add("transition", "duration-500", "ease-out")
      this.readoutTarget.classList.remove("opacity-0", "translate-y-2")
    })
  }
}
